define(
    'utils/form-poster',['jquery', 'settings', 'utils/toast'],

    function ($, settings2, toast) {
        /**
         * Posts forms without any page reload, using iframes
         * because of compatibilty issues with ajax file uploads
         *
         * @class FormPoster
         * @param $form
         * @param options
         * @constructor
         */
        function FormPoster($form, options) {
            this.$form = $form;

            this.settings = $.extend({
                submitOnFileDrop: false,
                highlightFileFieldsOnFileDrag: true,
                dimPageOnFileDrag: false
            }, options);

            this._configForm();
            this._insertIframe();
            this._bindSubmit();
            this._bindAutoSubmit();
            this._bindFieldHighlight();
        }

        /**
         * Add callbacks on events (submit & load)
         *
         * @method on
         * @param event
         * @param cb
         */
        FormPoster.prototype.on = function (event, cb) {
            switch (event) {
                case 'submit':
                    this.submitCallback = cb;
                    break;

                case 'load':
                    this.loadCallback = cb;
                    break;
            }

            return this;
        };

        /**
         * Bind load listener on submit
         *
         * @method _bindSubmit
         * @private
         */
        FormPoster.prototype._bindSubmit = function () {
            var self = this;

            this.$form.on('submit', function (data) {
                if (self.submitCallback)
                    self.submitCallback();

                self._getHighlightDiv().hide();
                self._resetDragCounter();

                self.$iframe.on('load', function (data) {
                    // console.log('here', self.loadCallback);

                    if (self.loadCallback)
                        self.loadCallback();
                });
            });
        };

        /**
         * Automatically submit the form if file field emits the change event
         *
         * @method _bindAutoSubmit
         * @private
         */
        FormPoster.prototype._bindAutoSubmit = function (data) {
            if (this.settings.submitOnFileDrop) {
                var self = this;

                this.$form.find('input[type=file]').on('change', function () {

                    var files = self.$form[0][0].files;
                    var formData = new FormData();
                    formData.append("logo", files[0]);

                    for (i = 0; i < files.length; i++) {
                        self.$form.append('file' + i, files[i]);
                    }

                    $.ajax({
                        type: 'POST',
                        url: settings2.profileLogoApiUrl,
                        data: formData,
                        dataType: 'json',
                        async: false,
                        contentType: false,
                        processData: false,
                        success: function (res) {
                             if (res.status === "error") {
                                 toast.queueError(res.message, 5000);
                             }
                            
                            if (self.submitCallback)
                                self.submitCallback();

                            self._getHighlightDiv().hide();
                            self._resetDragCounter();

                            if (self.loadCallback)
                                self.loadCallback();
                        }
                    });
                });
            }
        };

        /**
         * Binds to drag events to show the field highlighter if enabled
         *
         * @method _bindFieldHighlight
         * @private
         */
        FormPoster.prototype._bindFieldHighlight = function () {
            if (this.settings.highlightFileFieldsOnFileDrag) {
                var self = this;
                this.dragCounter = 0;

                $('body').on('dragenter', function (event) {
                    if (self.dragCounter++ === 0) {
                        self._showHighlightDiv();
                    }
                }).on('dragleave', function () {
                    if (--self.dragCounter === 0) {
                        self._getHighlightDiv().hide();
                        self._resetDragCounter();
                    }
                });
            }
        };

        /**
         * Resets the drag counter and thus enables the drag effect to
         * be active again
         *
         * @method _resetDragCounter
         * @private
         */
        FormPoster.prototype._resetDragCounter = function () {
            this.dragCounter = 0;
        };

        /**
         * Show's the highlight div in the appropriate position
         *
         * @method _showHighlightDiv
         * @private
         */
        FormPoster.prototype._showHighlightDiv = function () {
            var $div = this._getHighlightDiv(),
                $input = this.$form.find('input[type=file]').eq(0),
                offset = $input.offset(),
                dimensions = { width: $input.width(), height: $input.height() };

            $div.css({
                display: 'block',
                position: 'absolute',
                'pointer-events': 'none',
                'z-index': 1010,
                top: offset.top,
                left: offset.left,
                width: dimensions.width,
                height: dimensions.height
            });

            if (this.settings.dimPageOnFileDrag)
                $div.css('outline', '9999px solid rgba(255, 255, 255, 0.75)');
        };

        /**
         * Creates or gets the highlight div to use
         *
         * @method _getHighlightDiv
         * @returns {*}
         * @private
         */
        FormPoster.prototype._getHighlightDiv = function () {
            var divId = this._getUniqueID() + '-highlight',
                $div = $('#' + divId);

            if ($div.length > 0)
                return $div;

            return $('<div id="' + divId + '" class="form-field-highlight"></div>').appendTo('body');
        };

        /**
         * Sets the form target to the iframe
         *
         * @method _configForm
         * @private
         */
        FormPoster.prototype._configForm = function () {
            this.$form.attr('target', this._getUniqueID());
        };

        /**
         * Inserts the iframe into the DOM
         *
         * @method _insertIframe
         * @private
         */
        FormPoster.prototype._insertIframe = function () {
            var html = '<iframe name="' + this._getUniqueID() + '" width="0" height="0"></iframe>';
            this.$iframe = $(html).insertAfter(this.$form);
        };

        /**
         * Creates or gets the current uniqueID
         *
         * @method _getUniqueID
         * @returns {string|*}
         * @private
         */
        FormPoster.prototype._getUniqueID = function () {
            if (!this._id)
                this._id = 'fposter-' + new Date().getTime() + String(Math.random()).slice(2);

            return this._id;
        };

        return FormPoster;
    }
);

